import { NavLink } from 'react-router-dom';
import { useState, forwardRef } from 'react';
import styles from './header.module.css'
import '../../styles/global.css'

const Header = forwardRef((props, ref) => {
  const [open, setOpen] = useState(false)

  const toggleMenu = () => {
    setOpen(prev => !prev)
  }

  const closeMenu = () => {
    setOpen(false)
  }

  const handleScrollRegister = () => {
    const el = document.getElementById("register_form");
    el?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });

    // Đảm bảo URL không có hash
    window.history.replaceState(
      null,
      "",
      window.location.pathname
    );
  };

  return (
    <header ref={ref} className={styles.header}>
      <div className={`${styles.container} container`}>
        {/* LOGO */}
        <div className={styles.logo}>
          <img src='/images/main_logo.png' alt='Logo New Life' />
        </div>

        {/* HAMBURGER */}
        <div
          className={styles.menu_toggle}
          onClick={toggleMenu}
        >
          <img src='/icons/menu.svg' alt="menu" />
        </div>
        
        <div className={`${styles.navbar} ${open ? styles.open : ''}`}>
          <div className={styles.navbar_item} onClick={closeMenu}>
            <NavLink
              to="/"
              className={({ isActive }) =>
                isActive ? styles.active : undefined
              }
              end
            >
              Trang chủ
            </NavLink>
          </div>
          <div className={styles.navbar_item} onClick={closeMenu}>
            <NavLink
              to="/gioi-thieu"
              className={({ isActive }) =>
                isActive ? styles.active : undefined
              }
              end
            >
              Giới thiệu
            </NavLink>
          </div>
          <div className={styles.navbar_item} onClick={closeMenu}>
            <NavLink
              to="/dai-hoc-han-quoc"
              className={({ isActive }) =>
                isActive ? styles.active : undefined
              }
              end
            >
              Các trường liên kết
            </NavLink>
          </div>
          <div className={styles.navbar_item} onClick={closeMenu}>
            <NavLink
              to="/lien-he"
              className={({ isActive }) =>
                isActive ? styles.active : undefined
              }
              end
            >
              Liên hệ
            </NavLink>
          </div>
          <div className={styles.navbar_item} onClick={handleScrollRegister}>
            Đăng ký nhận ưu đãi
          </div>
        </div>
      </div>
    </header>
  );
}) 

export default Header;